import React from "react";

import {
  Container,
  FilterContainer,
  FilterLabel,
  FilterValue,
  VerticalDivider,
} from "./styles";

const FilterSingle = ({ label, value, hidden, isLast }) => {
  if (hidden) return null;

  const isBoolean = typeof value === "boolean";
  let text = "All";
  let hasColor = false;
  const validLength = Array.isArray(value) ? value.length : Date.parse(value) > 0 ? 1 : value;
  const isEmpty = validLength === 0;
  const hasOneValue = validLength === 1;
  const hasMoreValues = validLength > 1;

  if (isBoolean) {
    text = value ? "Yes" : "No";
    hasColor = !!value;
  } else if (isEmpty) {
    text = "All";
  } else if (hasOneValue) {
    text = value;
    hasColor = true;
  } else if (hasMoreValues) {
    text = `${validLength} selected`;
    hasColor = true;
  } else {
    text = "All";
  }

  return (
    <FilterContainer>
      <FilterLabel>{label}:</FilterLabel>
      <FilterValue hasColor={hasColor}>{text}</FilterValue>
      {!isLast ? <VerticalDivider /> : null}
    </FilterContainer>
  );
};

const FilterText = (props) => {
  const { filters, selectedFilters } = props;

  return (
    <Container>
      {filters.map((f, index) => {
        const { name, label, idMap, mapId, mapName } = f;

        let selected = selectedFilters[name];

        if (idMap && idMap.length > 0 && selectedFilters[name]) {
          selected = [];

          selectedFilters[name].forEach((s) => {
            if (mapId && mapName) {
              selected.push(idMap.find((i) => i[mapId] == s)[mapName]);
            } else {
              selected.push(idMap.find((i) => i.id === s).name);
            }
          });
        }

        return (
          <FilterSingle
            label={label}
            value={selected}
            //  hidden={filterLabels.find((l) => l.name === key).hidden}
            isLast={index === filters.length - 1}
          />
        );
      })}
      {/* {Object.keys(filters).map((key, index) => (
        <FilterSingle
          label={filterLabels.find((l) => l.name === key).label}
          value={filters[key]}
          hidden={filterLabels.find((l) => l.name === key).hidden}
          isLast={index === Object.keys(filters).length - 1}
        />
      ))} */}
    </Container>
  );
};

export default FilterText;
